import { ThemeModule } from '../../front/lib/ThemeModule';
export class ConferenceProgramme extends ThemeModule {
    constructor() {
        super(...arguments);
        this.headerEl = this.getElementById('header');
        this.hideBtnEl = this.getElementById('closeBtn');
        this.bodyEl = this.getElementById('body');
        this.innerEl = this.getElementById('inner');
    }
    init() {
        this.headerEl.addEventListener('click', () => this.toggle());
        this.hideBtnEl.addEventListener('click', () => this.close());
    }
    open() {
        this.root.classList.add('is--active');
        this.headerEl.setAttribute('aria-expanded', 'true');
        this.hideBtnEl.setAttribute('aria-expanded', 'true');
        this.headerEl.querySelector('.themeButton-title').innerHTML = 'Dölj program';
        this.bodyEl.style.height = this.innerEl.scrollHeight + 'px';
    }
    close() {
        this.root.classList.remove('is--active');
        this.headerEl.setAttribute('aria-expanded', 'false');
        this.hideBtnEl.setAttribute('aria-expanded', 'false');
        this.headerEl.querySelector('.themeButton-title').innerHTML = 'Se program';
        this.bodyEl.style.height = '';
    }
    isOpen() {
        return this.root.classList.contains('is--active');
    }
    toggle() {
        this.isOpen() ? this.close() : this.open();
    }
}
